function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { defineStyleConfig, forwardRef, useStyleConfig } from "@chakra-ui/react";
import { getTypographyStyles } from "../typography/utils";
import { tempo } from "../system";
const baseStyle = {
    alignItems: 'center',
    borderRadius: '2xs',
    display: 'inline-flex',
    justifyContent: 'center',
    height: 'fit-content'
};
const sizes = {
    medium: _object_spread_props(_object_spread({}, getTypographyStyles('body.m.default')), {
        minW: 'size.l',
        paddingX: 'spacing.xs',
        paddingY: 'spacing.2xs'
    }),
    small: _object_spread_props(_object_spread({}, getTypographyStyles('body.xs.default')), {
        minW: '20px',
        paddingX: 'spacing.xs',
        paddingY: 'spacing.2xs'
    }),
    xsmall: _object_spread_props(_object_spread({}, getTypographyStyles('body.xs.default')), {
        minW: 'size.xs',
        paddingX: 'spacing.xs',
        paddingY: '0'
    })
};
const variants = {
    neutral: {
        backgroundColor: 'background.neutral.tertiary.default',
        color: 'text.neutral.secondary.default'
    },
    inverse: {
        backgroundColor: 'background.neutral.inverse.default',
        color: 'text.neutral.inverse.default'
    },
    accent: {
        backgroundColor: 'background.accent.primary.default',
        color: 'text.accent.onDark.default'
    },
    live: {
        backgroundColor: 'background.feedback.error.default',
        color: 'text.accent.onDark.default'
    },
    onContent: {
        backgroundColor: 'background.accent.onContent.default',
        borderWidth: 'border.s',
        borderStyle: 'solid',
        borderColor: 'border.accent.onContent.default',
        color: 'text.accent.onContent.default',
        height: 'fit-content'
    }
};
export const ThemedLabel = defineStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        variant: 'neutral',
        size: 'medium'
    }
});
export const Label = forwardRef(function Label(_param, ref) {
    var { variant = 'neutral', size = 'medium', children } = _param, otherProps = _object_without_properties(_param, [
        "variant",
        "size",
        "children"
    ]);
    const styles = useStyleConfig('Label', {
        variant,
        size
    });
    return /*#__PURE__*/ _jsx(tempo.span, _object_spread_props(_object_spread({
        ref: ref,
        __css: _object_spread({
            alignItems: 'center',
            borderRadius: '2xs',
            display: 'inline-flex',
            justifyContent: 'center'
        }, styles)
    }, otherProps), {
        children: children
    }));
});
Label.displayName = 'Label';

//# sourceMappingURL=Label.js.map